/*
 * CG-CUSTOM 2026-10-13 - Party & More - header fix A (CommerceGenie / Jenny Como)
 * ---------------------------------------------------------------------------
 * CommerceGenie runs the sticky header itself. Empire's own sticky script is OFF
 * (Theme editor > Header > "Sticky header" unticked) because:
 *   1. its 110px -> 58px height change made the whole page jump while scrolling;
 *   2. its open/close lock got stuck on fast scrolls (menu row missing at the top).
 * This file reuses Empire's own classes (site-header-sticky, site-header-sticky--scrolled,
 * site-header-nav--open), so the docked look from "CG header styles" is unchanged.
 * Loaded from: Header group > "CG header styles (do not delete)" (script tag at the end).
 * Registry: KB clients/party-and-more/cg-theme-customizations-registry.md (13 Oct 2026).
 * REVERT: remove the <script> tag + <style id="cg-header-fix-a"> from "CG header styles",
 *         tick "Sticky header" again, then delete this file.
 */
(function () {
  var header = document.querySelector('header.site-header[data-site-header]');
  if (!header) return;
  var main = header.querySelector('[data-site-header-main]');
  // Safety: if Empire's own sticky header is switched back on, stay out of its way.
  if (main && main.hasAttribute('data-site-header-sticky')) return;

  var desktop = window.matchMedia('(min-width: 1024px)');
  var DOCK_AT = 160;   // dock (compact header) once scrolled past 160px
  var UNDOCK_AT = 60;  // undock only when back above 60px (the gap stops flicker)
  var docked = false;
  var reserve = 0;     // full header height at the top of the page
  var settleTimer = null;
  var ticking = false;

  // Spacer right after the header: when the header shrinks, the spacer grows by the same
  // amount, so nothing below the header moves (no jump, no scroll correction).
  // (A margin on the header doesn't work: it collapses with the next section's margin.)
  // It sits just after the header's section and sets its own height with !important,
  // because theme CSS for header-group sections otherwise squashes it to 0.
  var spacer = document.createElement('div');
  spacer.className = 'cg-header-spacer';
  spacer.setAttribute('aria-hidden', 'true');
  spacer.style.setProperty('display', 'block', 'important');
  spacer.style.setProperty('max-height', 'none', 'important');
  spacer.style.setProperty('margin', '0', 'important');
  spacer.style.setProperty('padding', '0', 'important');
  spacer.style.setProperty('transition', 'none', 'important'); // must resize instantly (theme reduced-motion CSS adds a transition to everything)
  var section = header.closest('.shopify-section') || header;
  section.insertAdjacentElement('afterend', spacer);
  function setSpacer(px) { spacer.style.setProperty('height', px + 'px', 'important'); }

  document.body.classList.add('site-header-sticky', 'cg-sticky');

  function setDocked(on) {
    if (on === docked) return;
    docked = on;
    header.classList.toggle('site-header-sticky--scrolled', on);
    header.classList.toggle('site-header-nav--open', !on); // menu row hidden when docked, shown at the top
    var btn = header.querySelector('[data-menu-toggle]');
    if (btn) btn.setAttribute('aria-expanded', on ? 'false' : 'true');
  }

  function compensate() {
    if (!desktop.matches) { setSpacer(0); return; }
    var h = header.offsetHeight;
    if (!docked) {
      if (!reserve) reserve = h;
      // Re-measure the full height once the header has settled (fonts/logo loaded,
      // undock animation finished, window resized).
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        if (!docked && desktop.matches) { reserve = header.offsetHeight; setSpacer(0); }
      }, 400);
    }
    setSpacer(Math.max(0, reserve - h));
  }

  function update() {
    ticking = false;
    if (!desktop.matches) {
      if (docked) setDocked(false);
      header.classList.add('site-header-nav--open');
      compensate();
      return;
    }
    var y = window.pageYOffset || document.documentElement.scrollTop;
    if (!docked && y > DOCK_AT) setDocked(true);
    else if (docked && y < UNDOCK_AT) setDocked(false);
    compensate();
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }, { passive: true });
  window.addEventListener('resize', update);
  if ('ResizeObserver' in window) new ResizeObserver(compensate).observe(header);

  // Hamburger while docked (desktop): show/hide the menu row. Runs before Empire's
  // handlers so the click doesn't open the mobile drawer on desktop.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('header.site-header [data-menu-toggle]');
    if (!btn || !desktop.matches || !docked) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var open = !header.classList.contains('site-header-nav--open');
    header.classList.toggle('site-header-nav--open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }, true);

  // Read-only status for troubleshooting from the browser console: window.cgHeaderFixA()
  window.cgHeaderFixA = function () {
    return { docked: docked, reserve: reserve, header: header.offsetHeight, spacer: spacer.offsetHeight, y: window.pageYOffset };
  };

  compensate(); // measure the full (top-of-page) height before the first dock
  update();
})();
